"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.faqsNormalizer = void 0;
/**
 * normalizador del modulo COMPONENT_TYPE
 * @param {object} fields
 * @returns
 */
const faqsNormalizer = (data) => {
    try {
        let res = {};
        const { fields } = data;
        res.componentId = fields === null || fields === void 0 ? void 0 : fields.componentId;
        const activityId = (fields === null || fields === void 0 ? void 0 : fields.activityId).split("::");
        res.activityId = activityId[1];
        const creativityId = (fields === null || fields === void 0 ? void 0 : fields.id).split("::");
        res.creativityId = creativityId[1];
        const creativityIdLogged = (fields === null || fields === void 0 ? void 0 : fields.loggedId).split("::");
        res.creativityIdLogged = creativityIdLogged[1];
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.faqsNormalizer = faqsNormalizer;
exports.default = exports.faqsNormalizer;
//# sourceMappingURL=index.js.map